<template>
  <div>
    <GoodsImageItem
      v-if="state.value"
      :move="false"
      :viewSizes="false"
      :previewImage="false"
      :initialIndex="0"
      :uploadStyle="uploadStyle"
      :preview-src-list="[state.value]"
      :key="state.value"
      :url="state.value"
      :checked="false"
      @uploading-change="onUploadChange"
      @remove="() => onRemove()"
      @change="(url:any)=>onChange(url)"
    />
    <GoodsUploadImageManage
      v-else
      :uploadStyle="uploadStyle"
      @uploading-change="onUploadChange"
      @upload-success="(url:any)=>onUploadSuccess(url)"
      @zone-selected="(urls:any)=>onZoneSelected(urls)"
      @add-link-images="(urls:any)=>onZoneSelected(urls)"
    >
      <div class="add-image-box">
        <el-icon class="plus-icon"><Plus /></el-icon>
      </div>
    </GoodsUploadImageManage>
  </div>
</template>
<script lang="tsx">
import {
  CollectionTag,
  UploadFilled,
  Delete,
  Refresh,
  Picture,
  Download,
  Plus,
  ArrowDown,
} from "@element-plus/icons-vue";

import GoodsUploadImageManage from "~/components/common/GoodsUploadImageManage/index.vue";
import {
  defineComponent,
  computed,
  ComputedRef,
  reactive,
  onBeforeMount,
  h,
  onMounted,
  watch,
} from "vue";
import { UnwrapNestedRefs } from "@vue/reactivity";
import moment from "moment";
 
import lodash from "lodash-es"; 
 
import {
  ElMessageBox,
  ElMessage,
  ElButton,
  ElDropdown,
  ElNotification,
} from "element-plus";
import { $t } from "~/utils/index.js";
 
import GoodsImageItem from "./GoodsImageItem.vue";
export default defineComponent({
  name: "GoodsSingleUpload",
  props: {
    modelValue: {
      type: String,
      default: () => "",
    },
    uploadStyle: {
      type: String,
      default: "image",
    },
  },
  emits: ["update:modelValue"],
  components: {
    Plus,
    GoodsUploadImageManage,
    GoodsImageItem,
  },
  setup(props, ctx) {
 

    const state: UnwrapNestedRefs<any> = reactive({
      uploading: false,
      value: props.modelValue,
    });

    onBeforeMount(() => {});
    const refs: any = {};
    const setRef = (el: any, key: string) => {
      refs[key] = el;
    };

    watch(
      () => props.modelValue,
      (newVal: any) => {
        state.value = newVal;
      }
    );

    watch(
      () => state.value,
      (newVal: any) => {
        ctx.emit("update:modelValue", newVal);
      }
    );

    function onRemove() {
      state.value = "";
    }

    function onUploadChange(v: any) {
      state.uploading = v;
    }

    function onUploadSuccess(url: any, key: any) {
      state.value = url;
    }

    function onZoneSelected(urls: any[], key: any) {
      state.value = urls.pop();
    }

    return {
      setRef,

      onRemove,

      state,
 
      onUploadChange,
      onUploadSuccess,
      onZoneSelected,
    };
  },
});
</script>
<style lang="scss" scoped>
.tip-text {
  line-height: 12px;
  color: #909399;
  .tip-text-num {
    color: red;
  }
}
.top-toolbar {
  display: flex;
  align-items: center;
  .top-toolbar-btn {
  }
}
.top-toolbar-checkbox {
  margin-top: 0px;
  display: flex;
}
.top-toolbar-tip-wrap {
  display: flex;
  justify-content: space-between;
  .top-toolbar-tip-gray {
    color: #909399;
  }
  .top-toolbar-tip-danger {
    color: red;
  }
}
.image-list {
  margin: -5px -3px;
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
}
.add-image-box {
  width: 120px;
  height: 120px;
  margin: 3px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  position: relative;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  .plus-icon {
    font-size: 30px;
  }
}
.image-drag-list-group {
  display: flex;
  flex-wrap: wrap;

  .drag-wrap {
    display: flex;
  }
}
.picture-label-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  box-sizing: border-box;
  padding: 0 5px;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
